import React, { FC, useRef } from 'react';

import { AlertDialog, Button } from '@rbilabs/universal-components';

import { LogUserErrorSeverity, useGetAndLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';

import { useCheckoutState } from '../../checkout-provider';
import { useCheckoutValidation } from '../../hooks/use-checkout-validation';

import CheckoutErrorCell from './checkout-error-cell';
import { StyledHeader } from './styled';

export const CheckoutErrorsModal: FC<React.PropsWithChildren> = () => {
  const [{ errorModalOpen }, setCheckoutState] = useCheckoutState();
  const { validate } = useCheckoutValidation();
  const checkoutErrors = validate();

  const getUnableToPlaceOrderMessage = useGetAndLogUserErrorMessage({
    message: t('unableToPlaceOrder'),
    severity: LogUserErrorSeverity.Recoverable, // likely recoverable but could be irrecoverable
    context: { moreInfo: 'CheckoutErrorsModal' },
  });

  const closeModal = () => {
    setCheckoutState(prev => ({ ...prev, errorModalOpen: false }));
  };

  const errors = checkoutErrors.filter(error => error.placement === 'errorDialog');
  const cancelRef = useRef(null);

  return (
    <AlertDialog
      // Blaine:
      // there is a bug, where if we pass this ref to the Button below,
      // the app crashes in react-router trying to find the react-navigation context
      // this makes zero sense. But I've found that if we just don't attach the
      // ref below then things don't crash :)
      leastDestructiveRef={cancelRef}
      isOpen={errorModalOpen}
      onClose={closeModal}
      testID="checkout-errors-dialog"
    >
      <AlertDialog.Content>
        <AlertDialog.Header>
          <StyledHeader variant="headerTwo">{getUnableToPlaceOrderMessage()}</StyledHeader>
        </AlertDialog.Header>
        <AlertDialog.Body>
          {errors.map(({ messageId, message }) => (
            <CheckoutErrorCell
              key={messageId ?? message}
              showDot={errors.length > 1}
              message={message}
              checkoutErrorId={(messageId as any) ?? ''}
            />
          ))}
        </AlertDialog.Body>
        <AlertDialog.Footer>
          <Button width="full" onPress={closeModal}>
            {t('okay')}
          </Button>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialog>
  );
};
